import { inject, Injectable } from '@angular/core';
import { SaService } from 'smartauction-frontend-micro-library';
import { Store } from '@ngxs/store';
import {
  InventoryManagementSearchResult, InventoryManagementSellerOffer,
  InventoryManagementState
} from 'remarketing-angular-library';

@Injectable({ providedIn: 'root' })
export class OfferFilterService extends SaService {

  private readonly store: Store;

  constructor() {
    super();
    this.store = inject(Store);
  }

  // returns the latest offer for a vehicle on an offer list.
  public filterLatestOfferByOfferList(inventoryManagementSearchResult: InventoryManagementSearchResult): InventoryManagementSellerOffer {
    const offers = this.filterOffersByOfferList(inventoryManagementSearchResult);
    // we can use a find here, as there should only be one latest offer for offers on an offer list.
    return offers.find(offer => offer.latestOffer === true);
  }

  public filterOffersByOfferList(inventoryManagementSearchResult: InventoryManagementSearchResult): InventoryManagementSellerOffer[] {
    const searchCriteriaOfferList = this.store.selectSnapshot(InventoryManagementState.searchCriteria)?.offerLists[0];

    const vehicleOffers = inventoryManagementSearchResult.offers.filter(
      offers => offers.offerListUuid === searchCriteriaOfferList
    );
    return vehicleOffers;
  }

}
